import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 44 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.85, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, accent }) => (
  <div className="mb-14 max-w-3xl">
    <Reveal>
      <span className="font-mono-alt text-xs uppercase tracking-[0.3em] text-amber-400">
        {eyebrow}
      </span>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title} <span className="text-amber-400">{accent}</span>
      </h2>
    </Reveal>
  </div>
);
